import useQuery from './useQuery';

const baseUrl = '/sellers/mine/';

function useMineQuery(params) {
  return useQuery(baseUrl, { staleTime: 60 * 1000, ...params });
}

export default useMineQuery;
